module.exports = __webpack_public_path__ + "img/xuanchuan02.4aeafe37.png";